import { Button, Col, Form, Row, Space, theme, Table, DatePicker, Select } from 'antd';
import React, { useEffect, useState } from 'react';
import LoadingBase from '../../components/LoadingBase';
import '../../css/listbook-page.css';
import { consoleLogUtil } from '../../utils/consoleLogUtil';
import dayjs from 'dayjs';
import { filterOption, filterShopsByUser } from '../../utils/funcHelper';
import { requiredItem } from '../../constants/constants';
import { getListShops, getOrdersReport } from '../../services/apis';
import { useSelector } from 'react-redux';

const ReportOrderByShop = () => {
    const { token } = theme.useToken();
    const [form] = Form.useForm();
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const { RangePicker } = DatePicker;
    const [dataShops, setDataShops] = useState([]);
    const userReducer = useSelector(state => state?.userReducer?.data);
    const columns = [
        {
            title: 'STT',
            width: 50,
            align: 'center',
            render: (text, record, index) => <div style={{ paddingTop: 8, paddingBottom: 8, paddingLeft: 12 }}>{index + 1}</div>
        },
        {
            title: 'Shop',
            dataIndex: 'shop_name',
            key: 'shop_name',
            render: (text, record) => <div style={{ paddingTop: 8, paddingBottom: 8, paddingLeft: 12}}>{text}</div>
        },
        {
            title: 'Total order sync',
            dataIndex: 'total_order',
            key: 'total_order',
            width: 150,
            align: 'center',
            render: (text, record) => <div style={{fontWeight: '700' }}>{text}</div>
        },
        {
            title: 'waiting',
            dataIndex: 'waiting',
            key: 'waiting',
            align: 'center',
            render: (text, record) => <div style={{fontWeight: '400' }}>{text}</div>
        },
        {
            title: 'processing',
            dataIndex: 'processing',
            key: 'processing',
            align: 'center',
            render: (text, record) => <div style={{fontWeight: '400' }}>{text}</div>
        },
        {
            title: 'completed',
            dataIndex: 'completed',
            key: 'completed',
            align: 'center',
            render: (text, record) => <div style={{fontWeight: '400' }}>{text}</div>
        },
        {
            title: 'canceled',
            dataIndex: 'canceled',
            key: 'canceled',
            align: 'center',
            render: (text, record) => <div style={{fontWeight: '400' }}>{text}</div>
        },
        
    ];

    const formStyle = {
        maxWidth: 'none',
        background: 'white',
        borderRadius: token.borderRadiusLG,
        paddingLeft: 0,
        paddingRight: 0,
        marginBottom: 12,
    };

    const getDataReport = async (startTime, endTime) => {
        const params = {
            shop_ids: form.getFieldValue('store_name') ?? [],
            from_date: startTime,
            to_date: endTime,
            user_id: userReducer?.user_info?.id
        }
        setLoading(true);
        const res = await getOrdersReport(params);
        consoleLogUtil('getDataReport', res);
        setLoading(false);
        if (res && res.status === 1) {
            setData([...res?.data || []]);
        } else {
            setData([]);
        }
    }
    const getDataShops = async () => {
        try {
            const res = await getListShops();
            consoleLogUtil('getListShops', res);
            if (res && res.status === 1) {
                const lstShop = res?.data?.data || [];
                const filterShops = filterShopsByUser(lstShop, userReducer);
                setDataShops([...filterShops?.map((item, index) => ({ ...item, value: item?.shop_id, label: `${index + 1}. ${item?.shop_name}` })) || []]);
            } else {
                setDataShops([]);
            }
        } catch (error) {
            setDataShops([]);
        }
    }

    const onFinish = async (dataForm) => {
        if (dataForm && dataForm?.date) {
            getDataReport(dayjs(dataForm.date[0]).format("YYYY-MM-DD HH:mm:ss"), dayjs(dataForm.date[1]).format("YYYY-MM-DD HH:mm:ss"))
        } else {
            getDataReport(dayjs().format("YYYY-MM-DD") + "00:00:00", dayjs().format("YYYY-MM-DD HH:mm:ss"))
        }
    };
    

    useEffect(() => {
        getDataShops();
    }, []);
    return (
        <div className='container-content'>

            <Form form={form} name="advanced_search" style={formStyle} onFinish={onFinish}>
                <Row gutter={24}>
                    <Col span={6}>
                        <Form.Item
                            name={'store_name'}
                        >
                            <Select
                                showSearch
                                allowClear
                                placeholder={'Chọn  shop'}
                                style={{ width: '100%', height: 40 }}
                                defaultActiveFirstOption={false}
                                filterOption={filterOption}
                                notFoundContent={null}
                                options={dataShops}
                                maxTagCount={'responsive'}
                                mode='multiple'
                            />
                        </Form.Item>
                    </Col>
                    
                    <Col span={10}>
                        <Form.Item
                            name={'date'}
                            rules={requiredItem}
                        >
                            <RangePicker
                                style={{ height: 40, width: '100%' }}
                                format="YYYY-MM-DD HH:mm:ss"
                                showTime
                                allowClear={false}
                            />
                        </Form.Item>
                    </Col>


                    <Col span={2}>
                        <Space size="small">
                            <Button type="primary" htmlType="submit">
                                Tìm kiếm
                            </Button>
                        </Space>
                    </Col>
                </Row>
            </Form>
            <Table
                className='table-book'
                columns={columns}
                dataSource={data}
                pagination={false}
                rowKey={(record) => record?.id}
                scroll={{ x: 1300 }}
            />
            
            <LoadingBase loading={loading} />

        </div>
    )
}
export default React.memo(ReportOrderByShop);